import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
const logos = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/logo_viessmann.png",
  alt: "Viessmann"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/logo_ideal.png",
  alt: "Ideal Heating"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/logo_grant.png",
  alt: "Grant Engineering"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/logo_viessmann.png",
  alt: "Viessmann"
}];
const partners = [{
  name: "Viessmann",
  quote: "German engineering for Dublin homes.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/boiler_viessmann_install.png",
  description: "We install Viessmann for their industry-leading efficiency and stainless steel heat exchangers. These units are built to last, providing reliable heating and hot water for decades with minimal maintenance requirements.",
  link: "/BoilerInstallationPage"
}, {
  name: "Ideal Heating",
  quote: "British reliability, expertly fitted.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/boiler_ideal_logic.png",
  description: "Ideal boilers are the backbone of many Dublin heating systems. We choose them for their compact design, ease of servicing, and excellent warranty support, ensuring our customers have peace of mind year-round.",
  link: "/BoilerInstallationPage"
}];
export default function TrustedBoilerBrandsWeInstall() {
  return <section data-section-id="257076" id="trusted-boiler-brands-we-install" className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        
        {}
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24">
          <h2 className="text-4xl md:text-5xl font-default font-bold tracking-tighter mb-6 text-primary">
            Trusted Boiler Brands We Install
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-default leading-relaxed">
            We only partner with manufacturers who meet our strict standards for efficiency, durability, and after-sales support in Ireland.
          </p>
          
          <div className="mt-8 flex flex-col items-center">
            <p className="text-primary font-bold font-default mb-4">We install and service:</p>
            <ul className="flex flex-wrap justify-center gap-6 md:gap-8 text-muted-foreground font-default font-medium">
              <li className="flex items-center">Viessmann</li>
              <li className="flex items-center">Ideal</li>
              <li className="flex items-center">Grant</li>
            </ul>
          </div>
        </div>

        {}
        <div className="relative w-full overflow-hidden mb-24 md:mb-32 flex justify-center">
          <div className="flex gap-12 md:gap-24 items-center justify-center flex-wrap max-w-5xl">
            {logos.map((logo, i) => <div key={i} data-index={i} className="flex-shrink-0 group cursor-pointer p-4">
                <img src={logo.src} alt={logo.alt} className="h-10 md:h-14 w-auto object-contain grayscale opacity-50 transition-all duration-500 group-hover:grayscale-0 group-hover:opacity-100" />
              </div>)}
          </div>
        </div>

        {}
        <div className="grid md:grid-cols-2 gap-8 lg:gap-16 max-w-6xl mx-auto relative">
          {}
          <div className="hidden md:block absolute top-0 bottom-0 left-1/2 w-px bg-border/60 -translate-x-1/2"></div>

          {partners.map((partner, i) => <Card key={i} data-index={i} className="bg-card border-border shadow-lg overflow-hidden group hover:shadow-xl transition-all duration-500 flex flex-col">
              <div className="aspect-[4/3] overflow-hidden relative">
                <img src={partner.image} data-wvc-srcset={`${partner.image}-wvc-srcset`} data-wvc-sizes={`${partner.image}-wvc-sizes`} alt={partner.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />
                <div className="absolute inset-0 bg-primary/10 group-hover:bg-transparent transition-colors duration-500"></div>
              </div>
              
              <CardHeader className="pt-8 pb-4 px-6 md:px-10">
                <span className="font-mono text-xs uppercase tracking-widest text-ring mb-4 block">
                  Premium Partner
                </span>
                <span className="font-serif italic text-foreground/80 text-lg md:text-xl mb-4 block">
                  "{partner.quote}"
                </span>
                <CardTitle className="text-3xl md:text-4xl font-default font-bold tracking-tight text-primary">
                  {partner.name}
                </CardTitle>
              </CardHeader>
              
              <CardContent className="px-6 md:px-10 pb-10 flex-grow flex flex-col justify-between">
                <p className="text-muted-foreground leading-relaxed text-lg font-default mb-8">
                  {partner.description}
                </p>
                
                <div>
                  <Link to={partner.link} className="inline-flex items-center text-primary font-bold hover:text-ring transition-colors font-default group/link">
                    View Installation Options 
                    <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover/link:translate-x-1" />
                  </Link>
                </div>
              </CardContent>
            </Card>)}
        </div>

      </div>
    </section>;
}